import { rest } from 'msw';
import { NAVIGATION_TYPE } from '@kakaopay-common/payweb-bridge';

import { BannerResponse } from '.';
import { API_URLS } from '~/configs/api/urls';

const MOCK_BANNER_RESPONSE: BannerResponse = {
  areas: [
    {
      section: 'banner',
      contents: [
        {
          title: '퀴즈를 맞추면 주식 금액이 커져요',
          lightTitleColor: '#060B11',
          darkTitleColor: '#FCFCFC',
          subTitle: '테스트 배너',
          lightSubTitleColor: '#7A060B11',
          darkSubTitleColor: '#8FFCFCFC',
          lightImageUrl: 'https://via.placeholder.com/80/FFFF00/000000',
          darkImageUrl: 'https://via.placeholder.com/80/FFFF00/000000',
          lightBgColor: '#F3F5F7',
          darkBgColor: '#383938',
          link: {
            type: 'URL',
            navigationType: NAVIGATION_TYPE.HIDE,
            androidUrl:
              'https://sandbox-fest.kakao.com/mts/promotion/double/main?t_src=contents&t_ch=wrapup_0321&t_obj=mts_mkt_goguma',
            iosUrl:
              'https://sandbox-fest.kakao.com/mts/promotion/double/main?t_src=contents&t_ch=wrapup_0321&t_obj=mts_mkt_goguma',
          },
        },
      ],
    },
  ],
};

const getContentsBannerMock = rest.get(
  `${API_URLS.BANNER}/:bannerType`,
  async (_, res, ctx) => res(ctx.json(MOCK_BANNER_RESPONSE))
);

export default getContentsBannerMock;
